import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../auth/service/auth.service';

@Component({
    selector: 'app-footer-expired',
    templateUrl: './footer-expired.component.html',
    styleUrls: ['./footer-expired.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterExpiredComponent implements OnInit {
  constructor(private authService: AuthService) {}

  ngOnInit(): void {}

  onLogout(): void {
    this.authService.logout();
  }
}
